import React, { Component } from "react";
import Popup from "reactjs-popup";
import axios from 'axios';
import { Grid, GridColumn, GridNoRecords, GridToolbar } from '@progress/kendo-react-grid';
import { process } from '@progress/kendo-data-query';
import { Button } from "@progress/kendo-react-buttons";
import { Input } from "@progress/kendo-react-inputs";
import { parseDate } from '@telerik/kendo-intl';
import { ComboBox } from '@progress/kendo-react-dropdowns';
import { DropDownList } from '@progress/kendo-react-dropdowns';

const textBooleanFields = [
    'IsShort',
    'TradesWithAI',
    'PaysOnMonthEnd',
    'ZeroCoupon',
];

const lcTextBooleanFields = textBooleanFields.map(f => f.toLowerCase());

const bitFields = [
    'IsUnsupervised'
];

const lcBitFields = bitFields.map(f => f.toLowerCase());

class EntityPopup extends Component {

    constructor(props) {
        super(props);


        this.state = {
            updates: [],
            dataState: {},
            EntityCode: '',

        }
    }

    componentDidMount() {

    }

    getDemographics = (cb) => {
        this.setState({ refreshText: 'Loading...' })
        var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };
        var demographics = [];



        axios(`api/securityMasterEntity`, {
            method: 'GET',
            params: {
                company: this.props.user.company,
                typeCode: this.props.typeCode,
                symbol: this.props.symbol,
            },
            headers: headers,
        })
            .then(response => {
                demographics = response.data.data[0]
                var d2 = []
                for (const p in demographics) {
                    d2.push({ field: p, label: p.replace(/([A-Z])/g, ' $1').trim(), value: demographics[p] })
                }
                var result = process(d2, this.state.dataState)
                this.setState({ demographics: d2, result: result, refreshText: '' });

            })
            .catch(err => {
                console.error(err);
            })
    }

    getClassifications = (cb) => {
        this.setState({ refreshText: 'Loading...' })
        var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };



        axios(`api/securityMasterClassifications`, {
            method: 'GET',
            params: {
                company: this.props.user.company,
            },
            headers: headers,
        })
            .then(response => {
                var data = response.data.data;

                const sortByOrder = (a, b) =>
                a.ClassificationMemberSortOrder - b.ClassificationMemberSortOrder;

                const AssetClass = data
                  .filter(x => x.ClassificationCode === 'AssetClass')
                  .sort(sortByOrder)
                  .map(x => ({
                      ...x,
                      displayText: `${x.ClassificationMemberCode} - ${x.ClassificationMemberDescription}`
                    }));

                const IndustryGroup = data
                  .filter(x => x.ClassificationCode === 'IndustryGroup')
                  .sort(sortByOrder)
                  .map(x => ({
                      ...x,
                      displayText: `${x.ClassificationMemberCode} - ${x.ClassificationMemberDescription}`
                    }));

                const Sector = data
                  .filter(x => x.ClassificationCode === 'Sector')
                  .sort(sortByOrder)
                  .map(x => ({
                      ...x,
                      displayText: `${x.ClassificationMemberCode} - ${x.ClassificationMemberDescription}`
                    }));

                const SecType = data
                  .filter(x => x.ClassificationCode === 'SecType')
                  .sort(sortByOrder)
                  .map(x => ({
                      ...x,
                      displayText: `${x.ClassificationMemberCode} - ${x.ClassificationMemberDescription}`
                    }));


                this.setState({ 
                    AssetClass: AssetClass, 
                    AssetClassAll: AssetClass, 
                    IndustryGroup: IndustryGroup, 
                    IndustryGroupAll: IndustryGroup, 
                    Sector: Sector, 
                    SectorAll: Sector, 
                    SecType: SecType, 
                    SecTypeAll: SecType
                }, () => { if (cb) { cb() } });


            })
            .catch(err => {
                console.error(err);
            })
    }

    processClassifications(updates){
        const sectorEntry = updates.find(obj => obj.field === "Sector");
        if (sectorEntry) {
            // Exists: update if value is falsy
            if (!sectorEntry.value) {
                sectorEntry.value = '0';
            }
        } else {
            // Doesn't exist: add new entry
            updates.push({ field: 'Sector', value: '0' });
        }
        const industryGroupEntry = updates.find(obj => obj.field === "IndustryGroup");
        if (industryGroupEntry) {
            // Exists: update if value is falsy
            if (!industryGroupEntry.value) {
                industryGroupEntry.value = '0';
            }
        } else {
            // Doesn't exist: add new entry
            updates.push({ field: 'IndustryGroup', value: '0' });
        }
        for (let i=0; i<updates.length; i++){
            if (lcTextBooleanFields.includes(updates[i].field.toLowerCase())){
                //varchar 'y'/'n' and must be converted
                if (updates[i].value === true){
                    updates[i].value = 'y'
                }
                else if (updates[i].value === false){
                    updates[i].value = 'n'
                }
            }
            if (lcBitFields.includes(updates[i].field.toLowerCase())){
                //bit true/false and must be converted
                if (updates[i].value === 'y'){
                    updates[i].value = true
                }
                else if (updates[i].value === 'n'){
                    updates[i].value = false
                }
            }    
        }

        return updates;
    }

    updateDemographics(cb) {
        if (this.validate()) {
            this.setState({ refreshText: 'Loading...' })
            var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };
            var demographicsEntry = [];

            if (this.props.create){//copy demographics, add date and RunDate 
                demographicsEntry = [...this.state.demographics];
                demographicsEntry.push({field: 'date', value: new Date()})
                
                
            }

            this.props.create ? this.processClassifications(demographicsEntry) : this.processClassifications(this.state.updates);

            var payload = {
                company: this.props.user.company,
                typeCode: this.props.typeCode || this.state.typeCode,
                symbol: this.props.symbol || this.state.symbol,
                updates: this.props.create ? demographicsEntry : this.state.updates,
            };

            axios.post('api/securityMasterEntity' + (this.props.create ? 'New' : ''), payload, { headers }).then(response => {
                cb()

            })
                .catch(err => {
                    console.error(err);
                })
        }
    }

    delete(cb) {
        if (window.confirm('Are you sure you want to delete ' + this.props.typeCode + ' - ' + this.props.symbol + '? This cannot be undone')) {
            this.setState({ refreshText: 'Loading...' })
            var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

            var payload = {
                company: this.props.user.company,
                typeCode: this.props.typeCode,
                symbol: this.props.symbol
            };

            axios.post('api/securityMasterEntityDelete', payload, { headers }).then(response => {
                cb(true)

            })
                .catch(err => {
                    console.error(err);
                })
        }
        else { cb(false) }
    }

    validate() {
        for (var u of (this.props.create ? this.state.demographics : this.state.updates)) {
            if (u.field === 'TypeCode') {
                if (!u.value) {
                    alert('TypeCode is required');
                    return false
                }
            }
            if (u.field === 'Symbol') {
                if (!u.value) {
                    alert('Symbol is required');
                    return false
                }
            }
            if (u.field === 'Description') {
                if (!u.value) {
                    alert('Description is required');
                    return false
                }
            }
            if (u.field === 'AssetClass') {
                if (!u.value) {
                    alert('Asset Class is required');
                    return false
                }
            }
            if (u.field.toLowerCase().includes('date')) {
                if (u.value && !parseDate(u.value)) {
                    alert('Dates must be in \'mm/dd/yyyy\' format')
                    return false
                }
            }
        }
        return true
    }

    clearState = () => {
        this.setState({
            updates: [],
            dataState: {},
            result: null,
            demographics: null,
            typeCode: '',
            symbol: ''
        });
    }

    onValueChange(field, value) {
        var updates = this.state.updates
        var demographics = this.state.demographics
        if (field === 'TypeCode') {
            this.setState({ typeCode: value })
        }
        if (field === 'Symbol') {
            this.setState({ symbol: value })
        }
        const i = updates.findIndex(e => e.field === field);
        const i2 = demographics.findIndex(e => e.field === field);
        if (i > -1) {
            updates[i].value = value
        }
        else {
            updates.push({ field: field, value: value })
        }
        demographics[i2].value = value
        var result = process(demographics, this.state.dataState)
        this.setState({ updates: updates, demographics: demographics, result: result })
    }

    formatDate(date) {
        var d;

        if (parseDate(date, "yyyy-MM-ddTHH:mm:ss.SSSXXX")) { d = parseDate(date, "yyyy-MM-ddTHH:mm:ss.SSSXXX") }
        else { d = parseDate(date, "MM/dd/yyyy HH:mm:ss") }

        const day = String(d.getUTCDate()).padStart(2, '0');
        const month = String(d.getUTCMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = d.getUTCFullYear();

        return `${month}/${day}/${year}`;

    }

    isDisabled(field) {
        switch (field) {
            case 'date':
                return true
            case 'Date':
                return true
            default:
                return false
        }
    }

    isLongerField(field) {
        switch (field) {
            case 'Name1':
                return true
            case 'Name2':
                return true
            case 'Name3':
                return true
            case 'Footnote1':
                return true
            case 'Footnote2':
                return true
            case 'Footnote3':
                return true
            case 'BillingNote':
                return true
            case 'BillingNote2':
                return true
            default:
                return false
        }
    }

    filterComboBox = (filter, data) => {
        if (!filter) {
            return data;
        }

        return data.filter(item =>
            item.displayText
                .toLowerCase()
                .includes(filter.toLowerCase())
        );
    }


    createCell = (cell) => {
        var isDisabled = this.isDisabled(cell.dataItem.field);
        var spanTip = <span></span>
        if (cell.dataItem.field.toLowerCase().includes('date')) {
            if (cell.dataItem.value && (parseDate(cell.dataItem.value, "yyyy-MM-ddTHH:mm:ss.SSSXXX") || parseDate(cell.dataItem.value, "MM/dd/yyyy HH:mm:ss"))) { cell.dataItem.value = this.formatDate(cell.dataItem.value).toString() };
            spanTip =  <span style={{fontSize:'85%', fontStyle:'italic', opacity:'0.8'}}>{'format: \'mm/dd/yyyy\''}</span>
        }
        else if (
          cell.dataItem.field === 'AssetClass' || 
          cell.dataItem.field === 'TypeCode' || 
          cell.dataItem.field === 'IndustryGroup' || 
          cell.dataItem.field === 'Sector'
        ){
            const fieldMap = {
                TypeCode: 'SecType',
                AssetClass: 'AssetClass',
                IndustryGroup: 'IndustryGroup',
                Sector: 'Sector'
            }; 
            const field = fieldMap[cell.dataItem.field] || '';

            let defaultBackup = null;
            if (cell.dataItem.field === 'IndustryGroup' || cell.dataItem.field === 'Sector') {
                defaultBackup = this.state[field + 'All'].find(
                x => x.ClassificationMemberCode === '0'
            );
            }
                     
            const selectedItem = this.state[field + 'All'].find(
                x => x.ClassificationMemberCode === cell.dataItem.value
            );

            return (
                <td>
                    <ComboBox
                        defaultValue={cell.dataItem.value || defaultBackup} 
                        style={{width:'100%'}}
                        key={cell.dataItem.field + 'Input'} 
                        data={this.state[field]}
                        disabled={isDisabled} 
                        textField="displayText"
                        dataItemKey="ClassificationMemberCode"
                        filterable
                        onFilterChange={(e) => {
                            this.setState({
                                [field]: this.filterComboBox(e.filter?.value, this.state[field + 'All']),
                            });
                        }}
                        value={selectedItem || defaultBackup} 
                        onChange={(e) => {
                            const value = e.target.value
                                ? e.target.value.ClassificationMemberCode
                                : null;

                            this.onValueChange(cell.dataItem.field, value);
                        }}
                    />
                </td>
            );
        }
        else if (lcTextBooleanFields.includes(cell.dataItem.field.toLowerCase())) {
            return (
                <td>
                  <DropDownList
                    data={['y', 'n']}
                    style={{width:'25%'}}
                    defaultValue={cell.dataItem.value || 'n'} // pre-select the current value
                    disabled={isDisabled}
                    value={
                      cell.dataItem.value === true
                        ? 'y'
                        : cell.dataItem.value === false
                        ? 'n'
                        : cell.dataItem.value // if it's already 'y' or 'n'
                    }
                    onChange={(e) => {
                      // Convert back to boolean if needed
                      const newValue = e.target.value === 'y' ? true : e.target.value === 'n' ? false : e.target.value;
                      this.onValueChange(cell.dataItem.field, newValue);
                    }}
                  />
                </td>
            )
        }

            return (
                <td>
                    <Input 
                        defaultValue={cell.dataItem.value} 
                        style={{width: this.isLongerField(cell.dataItem.field) ? '100%' : '50%'}} 
                        key={cell.dataItem.field + 'Input'} 
                        disabled={isDisabled} 
                        value={cell.dataItem.value} 
                        onChange={(e) => { 
                            this.onValueChange(cell.dataItem.field, e.target.value) 
                            }} 
                    /> {spanTip}
                </td>
            );
    }

    changeDataState = (e) => {
        var data = { ...e.dataState }
        if (data.filter != null && data.filter.filters != null) {
            data.filter.filters.forEach(item => {
            })
            // data.filter.filters = data.filter.filters.filter(item => item.value !== '(All)');
        }
        var newData = process(this.state.demographics, data);
        this.setState({ dataState: data, result: newData });
    }

    opened() {
        this.setState({ typeCode: this.props.typeCode, symbol: this.props.symbol });
        this.getClassifications(cb => {
            this.getDemographics(cb);
        });
    }

    render() {
        return (
            <Popup closeOnDocumentClick={false} trigger={this.props.button} onOpen={() => { this.opened(); }} onClose={() => { this.clearState(); this.props.refresh(); }} overlayStyle={{ zIndex: 5 }} modal>
                {close => (
                    <div className="modal">
                        <Button className="close" icon="close" onClick={(e) => { close(); }} />
                        <div className="header" align="left">
                            {this.props.create ? 'Create New' : 'Edit - ' + this.props.typeCode + ' ' + this.props.symbol}
                        </div>
                        <div className="content">
                            <Grid data={this.state.result}
                                style={{height:'65vh'}}
                                onDataStateChange={this.changeDataState}
                                {...this.state.dataState}>
                                <GridNoRecords>
                                    {this.state.refreshText && ''}
                                    {!this.state.refreshText && 'No records available'}
                                </GridNoRecords>
                                <GridToolbar>
                                    {!this.props.create && <Button icon='refresh' title='Refresh' onClick={(e) => this.getDemographics()}>{this.state.refreshText}</Button>}
                                    {!this.props.create && <Button icon="delete" title='Delete' onClick={() => { this.delete((cb) => { if (cb) { close() } }) }}>{'Delete ' + this.props.typeCode + ' ' + this.props.symbol}</Button>}
                                </GridToolbar>
                                <GridColumn field="label" key='labelCol' title="Label" width="165px" filterable={true} />
                                <GridColumn field="value" key='valueCol' title="Value" width="250px" filterable={true} cells={{data: (props) => this.createCell(props)}} />
                            </Grid>
                        </div>
                        <div className="actions">
                            <Button
                                className="button"
                                onClick={() => { close(); }}>
                                Cancel
                            </Button>
                            <Button
                                className="upload"
                                onClick={() => { this.updateDemographics(() => { close(); }) }}>
                                {this.props.create ? 'Save' : 'Update'}
                            </Button>
                        </div>
                    </div>
                )}
            </Popup>

        );
    };
}

export default EntityPopup;